import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FF6B35', // Laranja vibrante NostalBeat
      light: '#FF8C5A', // Laranja claro
      dark: '#E0531D', // Laranja escuro
    },
    secondary: {
      main: '#00D4FF', // Cyan elétrico
      light: '#33DDFF', // Cyan claro
      dark: '#00A8CC', // Cyan escuro
    },
    accent: {
      main: '#8B5CF6', // Roxo neon retrowave
      light: '#A78BFA',
      dark: '#7C3AED',
    },
    background: {
      default: '#0A0A0A', // Fundo dark suave
      paper: '#111111', // Card/Papel com contraste
    },
    success: {
      main: '#10B981', // Verde neon suave
      light: '#34D399',
      dark: '#059669',
    },
    error: {
      main: '#FF1744', // Vermelho vibrante
      light: '#FF5252',
      dark: '#D50000',
    },
    warning: {
      main: '#F59E0B', // Amarelo/âmbar
      light: '#FBBF24',
      dark: '#D97706',
    },
    info: {
      main: '#00D4FF',
      light: '#33DDFF',
      dark: '#00A8CC',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#E5E7EB',
      disabled: '#9CA3AF',
    },
  },
  
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Orbitron", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 900,
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
    },
    h2: {
      fontFamily: '"Orbitron", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 700,
      letterSpacing: '0.05em',
    },
    h3: {
      fontFamily: '"Orbitron", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 700,
    },
    h4: {
      fontFamily: '"Orbitron", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Orbitron", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 600,
    },
    h6: {
      fontFamily: '"Orbitron", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          textTransform: 'none',
          fontWeight: 600,
          padding: '8px 24px',
        },
        contained: {
          boxShadow: '0 0 20px rgba(255, 107, 53, 0.4)',
          '&:hover': {
            boxShadow: '0 0 30px rgba(255, 107, 53, 0.6)',
            transform: 'translateY(-2px)',
          },
          transition: 'all 0.3s ease',
        },
        outlined: {
          borderColor: '#FF6B35',
          color: '#FF6B35',
          '&:hover': {
            borderColor: '#FF8C5A',
            backgroundColor: 'rgba(255, 107, 53, 0.1)',
            boxShadow: '0 0 20px rgba(255, 107, 53, 0.3)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          background: 'rgba(17, 17, 17, 0.88)',
          '@media (min-width: 960px)': {
            backdropFilter: 'blur(10px)',
          },
          border: '1px solid rgba(255, 107, 53, 0.2)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
          '&:hover': {
            border: '1px solid rgba(255, 107, 53, 0.4)',
            boxShadow: '0 12px 40px rgba(255, 107, 53, 0.15)',
          },
          transition: 'all 0.3s ease',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            '& fieldset': {
              borderColor: 'rgba(255, 107, 53, 0.3)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(255, 107, 53, 0.5)',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#FF6B35',
              boxShadow: '0 0 20px rgba(255, 107, 53, 0.3)',
            },
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          fontWeight: 600,
        },
        colorPrimary: {
          backgroundColor: '#FF6B35',
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#FF8C5A',
          },
        },
        colorSecondary: {
          backgroundColor: '#00D4FF',
          color: '#000000',
          '&:hover': {
            backgroundColor: '#33DDFF',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(10, 10, 10, 0.95)',
          '@media (min-width: 960px)': {
            backdropFilter: 'blur(10px)',
          },
          borderBottom: '1px solid rgba(255, 107, 53, 0.2)',
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;
